import React from "react";
import { useObserver } from "mobx-react-lite";
import { Grid, Typography } from "@material-ui/core";
import { Link, Dialog, Table } from "components";
import { StoreProvider, useStore } from "./Store";
import { FormStoreProvider, useFormStore } from "./FormStore";
import Form from "./Form";

export const Page = () => {
  const store = useStore();
  const formStore = useFormStore();

  React.useEffect(() => {
    store.fetchAgencies();
  }, [store]);

  const open = React.useCallback(() => formStore.modal(true), [formStore]);
  const close = React.useCallback(() => formStore.modal(false), [formStore]);

  return useObserver(() => (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs="auto">
        <Typography variant="h6" color="textSecondary">
          代理店
        </Typography>
      </Grid>

      <Grid item xs="auto">
        <Dialog
          open={formStore.open}
          title="代理店"
          onOpen={open}
          onClose={close}
        >
          <Form />
        </Dialog>
      </Grid>

      <Grid item xs={12}>
        <Table
          title=""
          isLoading={store.loading}
          options={{
            exportFileName: "代理店",
          }}
          data={store.agencies}
          columns={[
            {
              title: "名前",
              field: "name",
              render: (agency) => (
                <Link to={`/agencies/${agency.id}/apps`}>{agency.name}</Link>
              ),
            },
          ]}
          actions={[
            {
              icon: "edit",
              tooltip: "編集",
              onClick: (_, agency) =>
                !Array.isArray(agency) &&
                formStore.modal(true, {
                  id: agency.id,
                  name: agency.name,
                }),
            },
          ]}
        />
      </Grid>
    </Grid>
  ));
};

export default () => (
  <StoreProvider>
    <FormStoreProvider>
      <Page />
    </FormStoreProvider>
  </StoreProvider>
);
